export function ignoreArrays(input?: string | string[]): string | null {
  return typeof input === "string" ? input : null;
}
